import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import Swal from 'sweetalert2';

import Auxiliary from '../../hoc/Auxiliary/Auxiliary';
import { filterErrorHandler } from '../../hoc/Shared/utility';
import SlotFreeSpinListing from './SlotFreeSpinListing';
import SlotFreeSpinShow from './SlotFreeSpinShow';
import SlotFreeSpinCreate from './SlotFreeSpinCreate';
import SlotFreeSpinAddMember from './SlotFreeSpinAddMember';
// import SlotFreeSpinEdit from './SlotFreeSpinEdit';

import * as actions from '../../store/ducks/slotFreeSpin/actions';

const initialInputState =
{
    start_date: "",
    end_date: "",
    date: "",
    title: "",
    reference_code: "",
    id: "",
    vendor: "",
};

class SlotFreeSpin extends Component
{
    /* ============ component lifecycle [START] ============ */
    constructor(props)
    {
        super(props);
        this.state =
        {
            /* component change */
            pageShow: 'listing',

            /* datatables / pagination */
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            order: null,
            totalPages: 0,
            totalRecords: 0,
            searchValue: '',

            /* form input value */
            filter: initialInputState,

            /* api result array */
            data: [],
            dropDown:
            {
                vendor: [],
            },

            /* details */
            selectId: null,
            referenceCode: null,
            vendorSlug: null,

            /* skeleton loading */
            loading: true,
        }
        this.onInputChange = this.onInputChange.bind(this);
    }

    componentDidMount()
    {
        const listingArr = this.getFilterArray();
        this.props.funcGetList(listingArr);
        this.props.funcGetDropDown(); // get filter drop down
    }

    shouldComponentUpdate(nextProps, nextState)
    {
    	// const { t } = this.props;
        if (nextProps.rs !== this.props.rs && nextProps.rs!==undefined)
        {
            if(nextProps.rs.responseCode === 200 && nextProps.rs.msgType === 'success')
            {
                this.setState({
                    data: nextProps.rs.data.result.row,
                    totalRecords: nextProps.rs.data.result.pagination.total_record,
                    totalPages: nextProps.rs.data.result.pagination.total_page,
                    loading: false,
                });
            }
            else
            {
                this.setState({
                    loading: false,
                    data: [],
                    totalRecords: 0,
                    totalPages: 0
                }, () => {
                    filterErrorHandler(nextProps.rs.message);
                });
            }
        }

        if (nextProps.dropDown !== this.props.dropDown && nextProps.dropDown!==undefined)
        {
            if(nextProps.dropDown.responseCode === 200 && nextProps.dropDown.msgType === 'success')
            {
                this.setState({
                    dropDown:
                    {
                        vendor: nextProps.dropDown.data.vendor,
                    }
                });
            }
            else {
                this.setState({
                    dropDown: {
                        vendor: [],
                    }
                }, () => {
                    filterErrorHandler(nextProps.dropDown.message);
                });
            }
        }

        // if (nextProps.updateStatus !== this.props.updateStatus && nextProps.updateStatus!==undefined)
        // {
        //     if(nextProps.updateStatus.responseCode === 200 && nextProps.updateStatus.msgType === 'success')
        //     {
        //         Swal.fire({
        //             icon: 'success',
        //             title: t('global.success'),
        //             html: t('global.record-updated'),
        //             showConfirmButton: true
        //         }).then(() =>
        //         {
        //             this.refreshHandler();
        //         });
        //     }
        //     else
        //     {
        //         Swal.close();
        //         this.setState({
        //             touched: false,
        //             errMsg: nextProps.updateStatus.message
        //         }, () => {
        //             filterErrorHandler(nextProps.updateStatus.message);
        //         });
        //     }
        // }

        return true;
    }
    /* ============ component lifecycle [END] ============ */

    /* ============ function [START] ============ */
    onInputChange = (event) =>
    {
        // console.log(event.target.id+' | '+event.target.value);
        let newFilter = Object.assign({}, this.state.filter);
        if(event.target.id==='transaction_date'){
            const date = (event.target.value!=='') ? event.target.value.split(" - ") : null;
            newFilter['start_date'] = (date) ? date[0] : '';
            newFilter['end_date'] = (date) ? date[1] : '';
            newFilter['date'] = event.target.value;
        }
        else{
            newFilter[event.target.id] = event.target.value;
        }
        this.setState({
            filter: newFilter
        });
    }

    searchKeyPressHandler = (event) =>
    {
        //Checking press the enter only perform search action
        if(event.key === 'Enter')
        {
            this.refreshHandler();
        }
    }

    clearHandler = () =>
    {
        this.setState({
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            order: null,
            filter: initialInputState,
            loading: true,
            data: [],
        }, ()=> 
        {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);
        });
    }

    loadingHandler = () =>
    {
        Swal.fire({
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
    }

    refreshHandler = () =>
    {
        this.setState({
            loading: true,
            data: [],
            errMsg: [],
            touched: false,
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            order: null,
        }, ()=> {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);
        });
    }

    getFilterArray = () =>
    {
        // this.loadingHandler();
        const listingArr = {};
        let availablePage = this.state.activePage;

        if (this.state.totalRecords !== 0) {
            availablePage = parseInt((this.state.totalRecords / this.state.limit) + 1);
            (this.state.activePage >= availablePage) && this.setState({ activePage: availablePage});
        }

        listingArr.page = (this.state.activePage >= availablePage) ? availablePage : this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.search = this.state.searchValue;
        listingArr.order = JSON.stringify(this.state.order);
        listingArr.country_id = this.props.currentUser.country_id;
        Object.keys(this.state.filter).forEach((val) =>
        {
            listingArr[val] = this.state.filter[val];
        });
        return listingArr;
    }

    addMemberHandler = (e, page, data) => 
    {
        e.preventDefault();
        this.setState({
            pageShow: page,
            selectId: data.id,
            referenceCode: data.reference_code,
            vendorSlug: data.vendor,
        });
    }

    changePageHandler = (page) =>
    {
        // console.log(page);
        this.setState({
            pageShow: page,
            errMsg: [],
            touched: false,
        });
    }

    detailsHandler = (e, page, id) =>
    {
        e.preventDefault();
        this.setState({
            pageShow: page,
            selectId: id,
        });
    }













    


    /* ============ function [END] ============ */

    /* ============ datatables function [START] ============ */
    datatablesChangeHandler = (val, act) =>
    {
        // console.log('datatablesChangeHandler :'+val + ' | '+act);
        this.setState({
            [act]: (act==='searchValue') ? val.target.value : val,
            loading: true,
            data: [],
            errMsg: [],
            touched: false,
        }, () => {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);
        });
    }

    onSort = (field, order) =>
    {
        const orderArry = [{}];
        let orderSequence = (order === 'asc') ? true : false ;

        orderArry[0]['id'] = field;
        orderArry[0]['desc'] = orderSequence;

        this.setState({
            order: orderArry,
            loading: true,
            data: [],
            errMsg: [],
            touched: false,
        }, () => {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);
        });
    }
    /* ============ datatables function [END] ============ */

    render()
    {
        return (
            <Auxiliary>
                {this.state.pageShow==='listing' &&
                    <SlotFreeSpinListing
                        /* filter input */
                        filter={this.state.filter}

                        /* setstate function */
                        onInputChange={(event) => this.onInputChange(event)}
                        datatablesChangeHandler={(val, act) => this.datatablesChangeHandler(val, act)}
                        detailsHandler={(event, page, id) => this.detailsHandler(event, page, id)}
                        changePageHandler={(event, page, id) => this.changePageHandler(event, page, id)}
                        addMemberHandler={(event, page, data) => this.addMemberHandler(event, page, data)}
                        onSort={(field, order) => this.onSort(field, order)}
                        // updateStatusHandler={(event) => this.updateStatusHandler(event)}
                        clearHandler={() => this.clearHandler()}
                        refreshHandler={() => this.refreshHandler()}
                        searchKeyPressHandler={(event) => this.searchKeyPressHandler(event)}

                        /* datatables data */
                        data={this.state.data}
                        activePage={this.state.activePage}
                        limit={this.state.limit}
                        totalRecords={this.state.totalRecords}
                        searchValue={this.state.searchValue}

                        /* filter drop down */
                        ddVendor={this.state.dropDown.vendor}

                        /* skeleton loading */
                        loading={this.state.loading}

                        /* user session */
                        currentUser={this.props.currentUser}
                    />
                }

                {this.state.pageShow==='show' &&
                    <SlotFreeSpinShow
                        {...this.state}
                        refreshHandler={() => this.refreshHandler()}
                        changePageHandler={(page) => this.changePageHandler(page)}
                    />
                }

                {this.state.pageShow==='create' &&
                    <SlotFreeSpinCreate
                        refreshHandler={() => this.refreshHandler()}
                        changePageHandler={(page) => this.changePageHandler(page)}
                    />
                }

                
                {this.props.currentUser.permission.includes('slot_free_spin_create') && this.state.pageShow === 'add_member' && 
                    <SlotFreeSpinAddMember
                        {...this.state}
                        refreshHandler={() => this.refreshHandler()}
                        changePageHandler={(page) => this.changePageHandler(page)}
                    />
                }
            </Auxiliary>
        );
    }
}

//Received the response from the redux calling the api response
const mapStateToProps = state =>
{
    return {
        rs: state.slotFreeSpin.rs,
        dropDown: state.slotFreeSpin.dropDown,
        currentUser: state.currentUser.data,
    }
};

//Using the redux calling api methods
const mapDispatchToProps = dispatch =>
{
    return {
        funcGetList: (filter) => dispatch(actions.getList(filter)),
        funcGetDropDown: () => dispatch(actions.getDropDown()),
    }
};

// Connect redux
export default connect(mapStateToProps, mapDispatchToProps) (withNamespaces('translation')(SlotFreeSpin));